import { __extends, __assign } from 'tslib';
import React__default from 'react';
import * as index from './icons/index.js';
import { propTypes, defaultProps } from './Icon.types.js';
import { deprecatedIconNames, deprecatedCorrespondingIcons } from './deprecated-icons.js';

/**
 * Icon
 *
 * A component that displays an icon
 *
 * You can adjust colors, sizes and alternative text through this component.
 * Additionally you can pass in a different icon set than the default one.
 *
 * NOTE:
 *
 * A word about creating icon sets...
 *  - If your SVG contains styles make sure you add a hash to the style so they are unique
 *  - If your SVG contains colors that you want adjusted, replace it with `currentColor`
 *  - Just export the SVG as a `ReactComponent` and import as an object
 *
 * NOTE:
 *
 * This component makes use of advanced JSX features:
 * https://reactjs.org/docs/jsx-in-depth.html#choosing-the-type-at-runtime
 *
 * The idea is:
 *  1) Import the components we want to use (icon components)
 *  2) Add references to said components in an obect literal (for accessing
 *      it... think set)
 *  3) Create a reference to they dynamic component type by
 *      - creating a new variable with the first letter capitalized (reference
 *      to component)
 *      - using the component type as a key we get the value in the object
 *      literal (map)
 *      - assign a value from the object literal to the CAPITALIZED variable
 *      (which is our reference)
 *
 *  See
 *  https://medium.com/@j5bot/react-dynamically-rendering-different-components-without-switch-the-capitalized-reference-e668d89e460b
 *  for a good explanation of what is going on here.
 *
 *  Since all icons are expected to be SVG and will take the same props, we
 *  probably don't need anything fancier than this.
 */
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.componentDidMount = function () {
        if (this.props.testId) {
            console.warn('DEPRECATION WARNING: The `testId` prop is deprecated and support for it will be removed soon. Please use `data-testid` instead.');
        }
        if (this.props.relativeSize) {
            console.warn('DEPRECATION WARNING: The `relativeSize` prop is deprecated and support for it will be removed soon. Please use `size` instead.');
        }
        if (this.props.noMargin) {
            console.warn('DEPRECATION WARNING: The `noMargin` prop is deprecated and support for it will be removed soon. Please use `size` instead.');
        }
        if (this.props.iconSet === index &&
            deprecatedIconNames.includes(this.props.name)) {
            console.warn("DEPRECATION WARNING: Icon with name: " + this.props.name + " is deprecated and support for it will be removed soon. Please use " + (deprecatedCorrespondingIcons[this.props.name] ||
                'another one from the icon component docs') + " instead.");
        }
    };
    Icon.prototype.render = function () {
        var _a = this.props, name = _a.name, alt = _a.alt, size = _a.size, color = _a.color, className = _a.className, iconSet = _a.iconSet, testId = _a.testId;
        // Get the icon
        var SelectedIcon = iconSet[name];
        if (!SelectedIcon) {
            console.warn("[Icon Component] No icon with name: " + name + " defined");
            return React__default.createElement("div", null);
        }
        return (React__default.createElement(SelectedIcon
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore-next-line
        , { 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            title: alt, alt: alt, className: className, width: size, height: size, style: {
                color: color,
                width: size,
                height: size,
            }, 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            stroke: 1.5, "data-testid": this.props['data-testid'] || testId }));
    };
    Icon.displayName = 'Icon';
    Icon.propTypes = propTypes;
    Icon.defaultProps = __assign({}, defaultProps);
    return Icon;
}(React__default.Component));

export { Icon, Icon as default };
